import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ParentSettingsForm from './SettingsForm';
import { updateProfile } from '../actions';
import { initialize } from 'redux-form';

class Profile extends Component {
	constructor(props) {
		super(props);
		this.handleParentSettingsSubmit = this.handleParentSettingsSubmit.bind(this);
	}

	// doesn't work, enableReinitialize on form works
	//componentWillReceiveProps(nextProps) {
	//	if (this.props.parent.id === 0 && nextProps.parent.id > 0) {
	//		// re-initialize parent settings form if parent data is loaded after the form is rendered
	//		this.props.initializeSettingsForm();
	//	}
	//}

	handleParentSettingsSubmit(values) {
		this.props.updateProfile(values);
	}

	render() {
		const { parent, cities, enableClassReminder, countryCode, timeZones, enableUserTimeZone, requireAddress, requirePostcode } = this.props;

		return (<div>
			<ParentSettingsForm onSubmit={this.handleParentSettingsSubmit}
				initialValues={parent}
				cities={cities}
				enableClassReminder={enableClassReminder}
				countryCode={countryCode}
				timeZones={timeZones}
				enableUserTimeZone={enableUserTimeZone}
				requireAddress={requireAddress}
				requirePostcode={requirePostcode}
			/>
		</div>);
	}
}

const mapStateToProps = state => {
	const { parent, entities: { centers }, configuration: { franchisor }, lookups: { timeZones } } = state;

	const cities = [...new Set(Object.keys(centers).map(key => centers[key].city))];	// distinct list of cities with centers

	return {
		parent,
		cities,
		enableClassReminder: franchisor.enableClassReminder,
		countryCode: franchisor.countryCode,
		timeZones,
		enableUserTimeZone: franchisor && franchisor.enableUserTimeZone,
		requireAddress: franchisor && franchisor.requireAddress,
		requirePostcode: franchisor && franchisor.requirePostcode
	};
};

export default connect(mapStateToProps, {
	updateProfile,
	initializeSettingsForm: () => initialize('parent')
})(withTranslation()(Profile));